import axios from "axios";
import { baseUrl, client, isAesEncryptionEnabled } from "../../Constants/index";
// axios.defaults.withCredentials = true;

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) prom.reject(error);
    else prom.resolve(token);
  });
  failedQueue = [];
};
axios.interceptors.response.use(
  res => res,
  async err => {

    const originalRequest = err.config;

    // If 401 and not retried yet
    if (err.response?.status === 401 && !originalRequest._retry) {

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then(token => {
            originalRequest.headers.Authorization = "Bearer " + token;
            return axios(originalRequest);
          })
          .catch(error => Promise.reject(error));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        // CALL REFRESH TOKEN API
        const refreshRes = await axios.post(`${baseUrl}auth/VConnectRefreshToken`,
          {},
          { withCredentials: client === 'DEN_HATHWAY' ? true : false }
        );

        const newToken = refreshRes.data?.responseMessageMISC;

        // SAVING NEW TOKEN
        localStorage.setItem("token", newToken);

        processQueue(null, newToken);

        // Retry original request
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return axios(originalRequest);

      } catch (e) {
        processQueue(e, null);
        if(isAesEncryptionEnabled === "true") {
          localStorage.setItem("AUTH_LOCK", "true");
        }
        return Promise.reject(e);

      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(err);
  }
);
